import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import { i18n } from './i18n';
// import { SecurityController } from '@/plugins/securityController';
// import { getBrowserLocale } from '@/plugins/utilities';
import './registerServiceWorker';
import '@mdi/font/css/materialdesignicons.css';

Vue.config.productionTip = false;
// router.beforeEach((to, from, next) => {
//   i18n.locale = getBrowserLocale();
//   if (to.matched.some((record) => record.meta.requiresAuth)) {
//       const sec = new SecurityController(null, null);
//       if (sec.username === '' || sec.username === null) {
//           next({
//               path: '/login',
//               params: { nextUrl: to.fullPath },
//           });
//       } else {
//           if (sec.sessionCheck()) {
//             next();
//           } else {
//             next({
//                 path: '/login',
//                 params: { nextUrl: to.fullPath },
//             });
//           }
//       }
//   } else {
//       next();
//   }
// });

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
